import { render, staticRenderFns } from "./ResearcherEligibility.vue?vue&type=template&id=e92735d6&scoped=true&"
import script from "./ResearcherEligibility.vue?vue&type=script&lang=js&"
export * from "./ResearcherEligibility.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherEligibility.vue?vue&type=style&index=0&id=e92735d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92735d6",
  null
  
)

export default component.exports